<template>
  <div class="home">
    <div class="container">
      <h1>《样品的记录、保存、包装和运送》</h1>
      <h2></h2>
      <h3>为保证准确诊断，必须在适当温度下、以最快速度，将样品仔细包装、做好标记和相关记录，以最快路线送到最近的兽医实验室。样品运输必须遵守农业农村部《高致病性动物病原微生物菌（毒）种运输包装规范》等规定。采样之前必须致电相关实验室，确保遵循正确的样品提交程序，保证所送样品能在第一时间完成检测及储存。做好样品运输过程中的安全保障工作，避免样品被污染。运送的样品必须附有足够数量的冷却材料（如冰袋），以防变质。</h3>
      <h2></h2>
      <h2>采样信息记录</h2>
      <h3>采样同时，应填写采样单。</h3>
      <h3>采样单应用钢笔或签字笔逐项填写（一式三份）。</h3>
      <h3>样品标签和封条应用签字笔填写。</h3>
      <h3>保温容器外封条应用钢笔或签字笔填写。</h3>
      <h3>小塑料离心管上可用记号笔做标记。</h3>
      <h3>应将采样单和病史资料装在塑料包装袋中，并随样品送实验室，每个样品应能对应到来源动物。</h3>
      <h2></h2>
      <h2>样品信息至少应包括以下内容：</h2>
      <h3>畜主姓名和养殖场地址；</h3>
      <h3>养殖场饲养动物品种及数量；</h3>
      <h3>疑似或被感染动物或易感动物种类及数量；</h3>
      <h3>首发病例和继发病例的日期；</h3>
      <h3>感染动物在畜群中的分布情况；</h3>
      <h3>死亡动物数、出现临床症状的动物数量及年龄；</h3>
      <h3>临床症状及其持续时间，死亡情况和时间等；</h3>
      <h3>饲养类型和标准，包括饲料来源等；</h3>
      <h3>送检样品清单和说明，包括病料种类、保存方法等；动物免疫和治疗史；</h3>
      <h3>送检者的姓名、地址、邮编、电话和邮箱；</h3>
      <h3>送检日期。</h3>
      <h2></h2>
      <h2>样品包装要求</h2>
      <h3>采集好的样品应仔细进行包装，做好标记并送到实验室。样品应使用“三重包装系统”，保障运输过程中的生物安全，并避免样品受到污染。推荐样品使用“三重包装系统”，并正确标记，以防止泄漏，内附采样单。直接盛装容器。样品应该储存在密封、无菌的主容器中，根据检验样品性状及检验目的选择不同的容器，每个样品容器外应做好标记，注明样品名、样品编号、采样日期等，要能明确识别来自于哪只动物。二次包装。吸收材料也应放置在二次容器内。如果将多个易碎的主容器放置在单个二次容器中，则必须单独包装或分离，以防止相互接触。二次包装容器应贴封条，封条上应有采样人签章，并注明贴封日期，标注放置方向。坚硬的外部包装。外包装在盛装液体的情况下不得超过 4 升，在固体物质的情况下不得超过 4 公斤（不包括冰的重量）。 </h3>
      <h3>注意：切勿冻结全血或混合有血凝块的血清。</h3>
      <h2></h2>
      <h2>外包装标签和标记</h2>
      <h3>采样负责人的全名、地址和电话号码；</h3>
      <h3>实验室联系人的全名、地址和电话号码；</h3>
      <h3>标签上标明“在4℃”,“在-20℃”或“在-80℃”保存。</h3>
      <p class="address-p">北京中科基因技术有限公司</p>
      <p class="address">2020年12月16日</p>
    </div>
  </div>
</template>

<script>
// import { shopCombination } from '@/api/resetApi.js'

export default {
  name: 'announcement',
  data(){
    return{
      tiem: '',
      timer: '',
      goodsList: [],
    }
  },
  created(){
  },
  methods: {
  }
}
</script>

<style lang="scss">
.home {
  max-width: 780px;
  margin: 0 auto;
}
.container {
  padding: 20px 10px;
  h1 {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    font-family: PingFangSC, PingFangSC-Semibold;
    color: #181818;
    padding-bottom: 10px;
  }
  h2 {
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    font-family: PingFangSC, PingFangSC-Semibold;
    color: #181818;
    padding-bottom: 10px;
  }
  h3 {
    text-align: left;
    font-size: 16px;
    font-weight: 400;
    font-family: PingFangSC, PingFangSC-Semibold;
    line-height: 25px;
    color: #666;
    padding-bottom: 10px;
  }
  p {
    padding-bottom: 10px;
    text-align: left;
    line-height: 25px;
    font-size: 12px;
    color: #000;
  }
  strong {
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    color: #000;
  }
  span {
    font-weight: bold;
    color: #ee1919;
  }
  .read {
    color: #ee1919;
  }
  .address-p {
    padding-bottom: 0;
    text-align: right;
  }
  .address {
    padding: 10px;
    text-align: right;
  }
}
</style>
